import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b5cab87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article__part-title" }
const _hoisted_2 = {
  key: 0,
  class: "article__content position-relative chart-wrapper"
}
const _hoisted_3 = { class: "chart-legend" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-name": "chart-number" }, "0", -1))

import { computed, reactive, ref, watch } from 'vue'
import { getCSSVar, getLocaleString } from '@/shared/helpers'
import { AvailableYear } from '@/pages/Report/model/types/report'
import ChartBarHor from '@/components/temp-component/ChartBarHor.vue'
import NotFoundBlock from '@/shared/ui/NotFoundBlock/NotFoundBlock.vue'
import { ProductType } from '@/entities/ProductTypes'
import { ActivityName } from '@/shared/consts/common'
import { availableYears } from '@/pages/Report/model/consts'
import { useReportStore } from '@/pages/Report'

type TrendSizedData = {
	[key in AvailableYear]?: Array<{
		name: string,
		color: string,
		percent: number,
		value: number,
		total: number
	}>
}

interface ChartDataItem {
	name: string,
	type: string,
	stack: string,
	label: {
		show: boolean,
		formatter: (params) => string
	},
	emphasis: {
		focus: string
	},
	color: string,
	data: Array<{
		value: number,
		total: number
	}>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendSizes',
  props: {
    typeOfProduct: null,
    activityType: null,
    instantInit: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	typeOfProduct: string,
	activityType: string,
	instantInit: boolean,
};

const queueOfColors = [
	getCSSVar('success-color'),
	getCSSVar('spirt-color'),
	getCSSVar('secondary-color'),
	getCSSVar('primary-color'),
	getCSSVar('alcohol-color'),
	getCSSVar('secondary-text-color')
]



const reportStore = useReportStore()

const data = reactive<TrendSizedData>({})
const stackMode = ref(true)
const isLoading = computed(() => reportStore.getIsLoading)
const seriesIsLoading = ref(true)
const series = ref<ChartDataItem[]>([])
const error = ref('')

const activityName = computed((): string => {
	if (props.activityType === ActivityName.PRODUCTION) {
		return 'производства'
	} else if (props.activityType === ActivityName.IMPORT) {
		return 'импорта'
	} else if (props.activityType === ActivityName.EXPORT) {
		return 'экспорта'
	} else {
		return 'продаж'
	}
})

const getShortProductType = computed((): string => {
	let res = ''

	switch (props.typeOfProduct) {
	case ProductType.DISTILLATES:
		res = 'sd'
		break
	case ProductType.WITH_ALCOHOL:
		res = 'ss'
		break
	case ProductType.ALCOHOL:
		res = 'ap'
		break
	case ProductType.ALCOHOL_WITHOUT_BEER:
		res = 'ap_without_beer'
		break
	case ProductType.BEER:
		res = ProductType.BEER
		break
	}

	return res
})

const createSeries = () => {
	const res: ChartDataItem[] = []

	const childs = data[availableYears[availableYears.length - 1]]

	const getDataOfAllYears = (name) => {
		const res = []

		availableYears.forEach(year => {
			const item = data[year]?.find(item => item.name === name)
			if (item) {
				res.push({
					value: item.value,
					total: item.total
				})
			}
		})

		return res
	}


	childs?.forEach(item => {
		res.push({
			name: item.name,
			type: 'bar',
			stack: stackMode.value ? 'total' : '',
			label: {
				show: false,
				formatter: (params) => getLocaleString(params.value)
			},
			emphasis: {
				focus: 'series'
			},
			color: item.color,
			data: getDataOfAllYears(item.name)
		})
	})

	series.value = res
	seriesIsLoading.value = false
}

const getAllYearsData = () => {
	availableYears.forEach(year => {
		const activityTypeOfYear = reportStore.state.activityTypesByYear[year][`at_${props.activityType}`]
		const category = activityTypeOfYear?.find(item => item.code === getShortProductType.value)
		error.value = ''
		data[year] = category?.childs?.map((item, i) => ({
			name: item.name,
			color: queueOfColors[i],
			percent: (+item.volume / category.volume * 100).toFixed(1),
			value: +item.volume.toFixed(),
			total: category.volume
		}))
	})

	createSeries()
}

watch(() => isLoading.value, () => {
	if (!isLoading.value) {
		setTimeout(getAllYearsData, 1000)
	}
}, {
	immediate: true
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", _hoisted_1, " Динамика объёмов " + _toDisplayString(_unref(activityName)) + " продукции " + _toDisplayString(props.typeOfProduct === _unref(ProductType).ALCOHOL ? 'за исключением пива' : ''), 1),
    (!_unref(isLoading) && series.value.length)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_unref(isLoading) && series.value.length)
            ? (_openBlock(), _createBlock(ChartBarHor, {
                key: 0,
                "instant-init": props.instantInit,
                series: series.value,
                "stack-mode": stackMode.value,
                action3nd: _unref(activityName)
              }, null, 8, ["instant-init", "series", "stack-mode", "action3nd"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(" Диаграмма №"),
            _hoisted_4,
            _createTextVNode(". Динамика объёмов " + _toDisplayString(_unref(activityName)) + " продукции ", 1)
          ])
        ])), [
          [_directive_loading, seriesIsLoading.value]
        ])
      : (_openBlock(), _createBlock(NotFoundBlock, {
          key: 1,
          text: "Данные не найдены"
        }))
  ]))
}
}

})